export const themeE = {
  name: "玫瑰暮光",
  colors: {
    bg: "#1C1018",
    bgSecondary: "#261620",
    text: "#F8ECF0",
    textSecondary: "#C4A8B4",
    textMuted: "#A88C99",
    accent: "#D4728C",
    accentText: "#1C1018",
    accentAlt: "#B86E8C",
    accentWarm: "#E8A4A0",
    accentOrange: "#D49478",
    available: "#8CB87A",
    availableText: "#1C1018",
    claimed: "#3E2E36",
    cardBg: "#221420",
    cardBorder: "#3A2832",
    overlay: "rgba(28,16,24,0.8)",
    heroBg: "#1C1018",
    heroText: "#F8ECF0",
  },
  fonts: {
    heading: "var(--font-cormorant), 'Noto Serif TC', serif",
    body: "var(--font-noto-sans), sans-serif",
    accent: "var(--font-cormorant), serif",
  },
  radius: { sm: "8px", md: "14px", lg: "20px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "52px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 16px rgba(212,114,140,0.08)",
    cardHoverShadow: "0 4px 24px rgba(212,114,140,0.14)",
    bgTexture: true,
    textureOpacity: 0.02,
  },
};
